import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { adjustLineItemQuantities } from '../../../actions/orders/adjustments'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

import AdjustQuantities from '../../../components/tabs/OrderDetailsModal/AdjustQuantities'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''

  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()

  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)

  const userNotes = order?.userNotes ?? ''

  return {
    order,
    suiteInformation,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}
  const orderDetailsPath = `/tabs/${orderId}`

  return {
    onAdjust: (args = {}) => {
      dispatch(adjustLineItemQuantities({ ...args, orderId }))
      replace(orderDetailsPath)
    },
    onClose: () => replace(orderDetailsPath),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdjustQuantities))
